import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import LoginPage from "@/pages/Login";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminSiswa from "@/pages/admin/SiswaPage";
import AdminPengasuh from "@/pages/admin/PengasuhPage";
import AdminKelompok from "@/pages/admin/KelompokPage";
import AdminPeriode from "@/pages/admin/PeriodePage";
import AdminPeriodeDetail from "@/pages/admin/PeriodeDetailPage";
import AdminSosio from "@/pages/admin/HasilSosioPage";
import AdminObservasi from "@/pages/admin/HasilObsPage";
import AdminNilaiGabungan from "@/pages/admin/NilaiGabunganPage";
import AdminRanking from "@/pages/admin/RankingPage";
import AdminSettings from "@/pages/admin/SettingsPage";

import PengasuhLayout from "@/pages/pengasuh/PengasuhLayout";
import PengasuhPeriode from "@/pages/pengasuh/PeriodeListPage";
import PengasuhRanking from "@/pages/pengasuh/InputRankingPage";
import PengasuhHasil from "@/pages/pengasuh/HasilPage";

import SiswaLayout from "@/pages/siswa/SiswaLayout";
import SiswaPeriode from "@/pages/siswa/PeriodePage";
import SiswaIsi from "@/pages/siswa/IsiSosiometriPage";

function ProtectedRoute({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Memuat...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/login" replace />;
  return children;
}

function RoleRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  if (user.role === "pengasuh") return <Navigate to="/pengasuh" replace />;
  if (user.role === "siswa") return <Navigate to="/siswa" replace />;
  return <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<RoleRedirect />} />

          <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminLayout /></ProtectedRoute>}>
            <Route index element={<AdminDashboard />} />
            <Route path="siswa" element={<AdminSiswa />} />
            <Route path="pengasuh" element={<AdminPengasuh />} />
            <Route path="kelompok" element={<AdminKelompok />} />
            <Route path="periode" element={<AdminPeriode />} />
            <Route path="periode/:periodeId" element={<AdminPeriodeDetail />} />
            <Route path="sosiometri" element={<AdminSosio />} />
            <Route path="observasi" element={<AdminObservasi />} />
            <Route path="nilai-gabungan" element={<AdminNilaiGabungan />} />
            <Route path="ranking" element={<AdminRanking />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>

          <Route path="/pengasuh" element={<ProtectedRoute roles={["pengasuh"]}><PengasuhLayout /></ProtectedRoute>}>
            <Route index element={<PengasuhPeriode />} />
            <Route path="periode/:periodeId/ranking" element={<PengasuhRanking />} />
            <Route path="periode/:periodeId/hasil" element={<PengasuhHasil />} />
          </Route>

          <Route path="/siswa" element={<ProtectedRoute roles={["siswa"]}><SiswaLayout /></ProtectedRoute>}>
            <Route index element={<SiswaPeriode />} />
            <Route path="periode/:periodeId" element={<SiswaIsi />} />
          </Route>

          <Route path="*" element={<RoleRedirect />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
